import { useGameStore } from '../store';
import { MDisplay } from './MDisplay';

export function Header() {
  const gameDate = useGameStore((state) => state.gameDate);

  // Format date for display - shorter format on mobile
  const dateObj = new Date(gameDate + 'T00:00:00');

  // Short format for mobile: "1/11"
  const shortDate = new Intl.DateTimeFormat('en-US', {
    month: 'numeric',
    day: 'numeric',
  }).format(dateObj);

  // Full format for desktop: "Jan 11, 2025"
  const fullDate = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(dateObj);

  return (
    <header className="sticky top-0 z-40 w-full bg-dark border-b border-gray-700 py-3 mb-4">
      <div className="container-game flex items-center justify-between">
        {/* Logo */}
        <h1 className="text-lg sm:text-xl text-teal font-pixel">RetireM</h1>

        {/* M Display - center/right */}
        <div className="flex items-center gap-3 sm:gap-6">
          <MDisplay />

          {/* Date - short on mobile, full on desktop */}
          <span className="text-sm text-gray-400 font-pixel">
            <span className="sm:hidden">{shortDate}</span>
            <span className="hidden sm:inline">{fullDate}</span>
          </span>
        </div>
      </div>
    </header>
  );
}
